import { OtpChannelEnum } from '../constantes/OtpChannelEnum';
import { OtpChannel } from '../_types/otp.types';
import { UserSearchResponse } from '../_types/user.types';


export const getChannelValue = (
  selectedChannel: OtpChannel,
  userData: UserSearchResponse | null
): string => {
  if (!userData) {
    return selectedChannel === OtpChannelEnum.EMAIL ? 'seu email' : 'seu telefone';
  }

  if (selectedChannel === OtpChannelEnum.EMAIL) {
    return userData.emailObfuscated || 'seu email';
  }

  return userData.phoneObfuscated || 'seu telefone';
}; 